<!-- <p>
  refund-status-not-refunded works!
</p> -->

<h1 class="h1-margin">{{pageData?.notrefunded?.heading}}</h1>
<br>
<div>
  <a routerLink="/refund/status/lookup">
    << {{pageData?.notrefunded?.backToSearch}} <span aria-hidden="true"></span>
  </a>
</div>
<br>

<!-- Displaying only one Status per Ticket -->
<div class="card">
  <div class="card-section-padding">
    <div
      *ngIf="refundStatusRs.refundStatus[0].isTransportTicket && refundStatusRs.refundStatus[0].scitDetails.sciDestinationCityState !== null">
      <h2 class="h2-margin">{{pageData?.notrefunded?.yourTripTo}}
        {{refundStatusRs.refundStatus[0].scitDetails.sciDestinationCityState}}</h2>
      <h3 id="cardHeadingId">{{refundStatusRs.refundStatus[0].scitDetails.sciUseDate | localizedDate:'fullDate' |
        capitalizeFirst}}</h3>
    </div>
    <div *ngIf="!refundStatusRs.refundStatus[0].isTransportTicket && refundStatusRs.refundStatus[0].tripCreditInd === 'Y'">
      <h2 class="h2-margin">{{pageData?.notrefunded?.tripCredit}}</h2>
    </div>
    <div *ngIf="!refundStatusRs.refundStatus[0].isTransportTicket && refundStatusRs.refundStatus[0].tripCreditInd === 'N'">
      <div [ngSwitch]="refundStatusRs.refundStatus[0].productDescription">
        <div *ngSwitchCase="'INSTANT UPSELL'">
          <h2 class="h2-margin">{{pageData?.notrefunded?.instantUpsell}}</h2>
        </div>
        <div *ngSwitchCase="'Prepaid Bags'">
          <h2 class="h2-margin">{{pageData?.notrefunded?.prepaidBags}}</h2>
        </div>
        <div *ngSwitchCase="'Mileage Reinstatement Fee'">
          <h2 class="h2-margin">{{pageData?.notrefunded?.mileReinstatementfee}}</h2>
        </div>
        <div *ngSwitchCase="'Group Deposits'">
          <h2 class="h2-margin">{{pageData?.notrefunded?.groupDeposits}}</h2>
        </div>
        <div *ngSwitchDefault>
          <h2 class="h2-margin">{{pageData?.notrefunded?.yourTrip}}</h2>
        </div>
      </div>
    </div>
    <div *ngIf="(!refundStatusRs.refundStatus[0].isTransportTicket || refundStatusRs.refundStatus[0].scitDetails.sciDestinationCityState === null) && refundStatusRs.refundStatus[0].tripCreditInd === null">
      <div [ngSwitch]="refundStatusRs.refundStatus[0].productDescription">
        <div *ngSwitchCase="'AWARD MAIN CABIN EXTRA'">
          <h2 class="h2-margin">{{pageData?.notrefunded?.mainCabinExtra}}
            ({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})
          </h2>
        </div>
        <div *ngSwitchCase="'MAIN CABIN EXTRA'">
          <h2 class="h2-margin">{{pageData?.notrefunded?.mainCabinExtra}}
            ({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})
          </h2>
        </div>
        <div *ngSwitchCase="'AWARD PREFERRED SEATS'">
          <h2 class="h2-margin">{{pageData?.notrefunded?.preferredSeat}}
            ({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})
          </h2>
        </div>
        <div *ngSwitchCase="'PREFERRED SEATS'">
          <h2 class="h2-margin">{{pageData?.notrefunded?.preferredSeat}}
            ({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})
          </h2>
        </div>
        <div *ngSwitchDefault>
          <h2 class="h2-margin">{{pageData?.notrefunded?.yourTrip}} <span
              *ngIf="refundStatusRs.refundStatus[0].scitDetails.sciOrigin && refundStatusRs.refundStatus[0].scitDetails.sciDestination">({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})</span>
          </h2>
        </div>
      </div>
      <br>
    </div>

    <div class="card-section-background">
      <div class="card-section">
        <div class="grid-x grid-margin-x">
          <div class="cell small-6 align-text-left">
            <div *ngIf="refundStatusRs.refundStatus[0].tripCreditInd === 'Y'; else elseBlock"> 
              <b>{{pageData?.notrefunded?.tripCreditNumber}} {{refundStatusRs.refundStatus[0].ticketNumber}}</b>
            </div>
            <ng-template #elseBlock>
              <b>{{pageData?.notrefunded?.ticketNumber}} {{refundStatusRs.refundStatus[0].ticketNumber}}</b>
            </ng-template>
          </div>
          <div class="cell small-6 align-text-right padding-text-right">
            <span class="tag-error">&nbsp;&nbsp;{{pageData?.notrefunded?.status}}&nbsp;&nbsp;</span>
          </div>
        </div>
        <div class="grid-x grid-margin-x">
          <div class="cell medium-6 large-8 align-text-left">
            {{pageData?.notrefunded?.message}} {{refundStatusRs.refundStatus[0].refundReceivedDate |
            localizedDate:'fullDate' | capitalizeFirst}}
          </div>
        </div>
        <hr>
        <div [ngSwitch]="refundStatusRs.refundStatus[0].refundStatusMessageCode">
          <div *ngSwitchCase="'NRD'">
            {{pageData?.notrefunded?.nrdMessage1}}
            <br><br>
            {{pageData?.notrefunded?.nrdMessage2}}
            <br><br>
            <div class="list-style standard-margin-bottom">
              <b id="deniedNRDHeading">{{pageData?.notrefunded?.nrdMessage3}}</b>
              <ul aria-labelledby="deniedNRDHeading" class="list-header-padding">
                <li>{{pageData?.notrefunded?.nrdMessage4}}</li>
                <li>{{pageData?.notrefunded?.nrdMessage5}}</li>
                <li>{{pageData?.notrefunded?.nrdMessage6}}</li>
                <li>{{pageData?.notrefunded?.nrdMessage7}}</li>
              </ul>
            </div>
            <br>
            {{pageData?.notrefunded?.nrdMessage8}}
          </div>
          <div *ngSwitchCase="'NRBE'">
            {{pageData?.notrefunded?.nrbeMessage1}}
            <br><br>
            {{pageData?.notrefunded?.nrbeMessage2}}
          </div>
          <div *ngSwitchCase="'FEES'">
            {{pageData?.notrefunded?.feesMessage1}}
          </div>
          <div *ngSwitchCase="'WAIV'">
            {{pageData?.notrefunded?.waivMessage1}}
            <br><br>
            {{pageData?.notrefunded?.waivMessage2}}
            <br><br>
            <div class="list-style standard-margin-bottom">
              <b id="deniedNRDHeading">{{pageData?.notrefunded?.waivMessage3}}</b>
              <ul aria-labelledby="deniedNRDHeading">
                <br>
                <li>{{pageData?.notrefunded?.waivMessage4}}</li>
                <li>{{pageData?.notrefunded?.waivMessage5}}</li>
                <li>{{pageData?.notrefunded?.waivMessage6}}</li>
              </ul>
            </div>
            <br>
            {{pageData?.notrefunded?.waivMessage7}}
          </div>
          <div *ngSwitchCase="'FARU'">
            {{pageData?.notrefunded?.faruMessage1}}
            <br><br>
            {{pageData?.notrefunded?.faruMessage2}}
          </div>
          <div *ngSwitchCase="'RREZ'">
            {{pageData?.notrefunded?.rrezMessage1}}
          </div>
          <div *ngSwitchCase="'VIAS'">
            {{pageData?.notrefunded?.viasMessage1}}
            <br><br>
            <a href="https://inflight.viasat.com/" target="_blank">{{pageData?.notrefunded?.viasMessage2}} <span
                aria-hidden="true" class="icon-newpage"></span></a>
          </div>
          <div *ngSwitchCase="'GOGO'">
            {{pageData?.notrefunded?.gogoMessage1}} <span class="link-blue"> customercare&#64;gogoair.com</span>
            {{pageData?.notrefunded?.gogoMessage2}}
          </div>
          <div *ngSwitchCase="'VFOP'">
            <ng-container *ngIf="isBeforeCutoffDate(refundStatusRs.refundStatus[0].refundDate)">
              {{pageData?.notrefunded?.vfopMessage1Voucher}}
            </ng-container>
            <ng-container *ngIf="!isBeforeCutoffDate(refundStatusRs.refundStatus[0].refundDate)">
              {{pageData?.notrefunded?.vfopMessage1}}
            </ng-container>
            <br><br>
            <ng-container *ngIf="isBeforeCutoffDate(refundStatusRs.refundStatus[0].refundDate)">
              {{pageData?.notrefunded?.vfopMessage2Voucher}}
            </ng-container>
            <ng-container *ngIf="!isBeforeCutoffDate(refundStatusRs.refundStatus[0].refundDate)">
              {{pageData?.notrefunded?.vfopMessage2}}
            </ng-container>
            <br><br>
            {{pageData?.notrefunded?.vfopMessage3}}
          </div>
          <div *ngSwitchCase="'NRBR'">
            {{pageData?.notrefunded?.nrbrMessage1}}
            <br><br>
            {{pageData?.notrefunded?.nrbrMessage2}}
            <br><br>
            <div class="list-style standard-margin-bottom">
              <b id="deniedNRDHeading">{{pageData?.notrefunded?.nrbrMessage3}}</b>
              <ul aria-labelledby="deniedNRDHeading">
                <br>
                <li>{{pageData?.notrefunded?.nrbrMessage4}}</li>
                <li>{{pageData?.notrefunded?.nrbrMessage5}}</li>
                <li>{{pageData?.notrefunded?.nrbrMessage6}}</li>
              </ul>
            </div>
            <br>
            {{pageData?.notrefunded?.nrbrMessage7}}
          </div>
          <div *ngSwitchCase="'WVBR'">
            {{pageData?.notrefunded?.wvbrMessage1}}
            <br><br>
            {{pageData?.notrefunded?.wvbrMessage2}}
            <br><br>
            {{pageData?.notrefunded?.wvbrMessage3}}
          </div>
          <div *ngSwitchCase="'ATQU'">
            {{pageData?.notrefunded?.atquMessage1}}
            <br><br>
            <b>{{pageData?.notrefunded?.atquMessage2}}</b>
            <br>
            <span class="link-blue">refunds&#64;aa.com</span>
            <br><br>
            <b>{{pageData?.notrefunded?.atquMessage3}}</b>
            <br>
            800-292-3447 {{pageData?.notrefunded?.atquMessage4}}
            <br>
            480-693-2759 {{pageData?.notrefunded?.atquMessage5}}
            <br><br>
            <b>{{pageData?.notrefunded?.atquMessage6}}</b>
            <br>
            American Airlines, Attention: Passenger Refunds
            <br>
            4000 East Sky Harbor Boulevard
            <br>
            Phoenix, Arizona, 85034
          </div>
          <div *ngSwitchCase="'MEDD'">
            {{pageData?.notrefunded?.meddMessage1}}
            <br><br>
            <b>{{pageData?.notrefunded?.meddMessage2}}</b>
            <br>
            <span class="link-blue">{{'refunds@aa.com'}}</span>
            <br><br>
            <b>{{pageData?.notrefunded?.meddMessage3}}</b>
            <br>
            800-292-3447 {{pageData?.notrefunded?.meddMessage4}}
            <br>
            480-693-2759 {{pageData?.notrefunded?.meddMessage5}}
            <br><br>
            <b>{{pageData?.notrefunded?.meddMessage6}}</b>
            <br>
            American Airlines, Attention: Passenger Refunds
            <br>
            4000 East Sky Harbor Boulevard
            <br>
            Phoenix, Arizona, 85034
          </div>
          <div *ngSwitchCase="'NCCS'">
            {{pageData?.notrefunded?.nccsMessage1}}
            <br><br>
            <b>{{pageData?.notrefunded?.nccsMessage2}}</b>
            <br>
            <span class="link-blue">{{'refunds@aa.com'}}</span>
            <br><br>
            <b>{{pageData?.notrefunded?.nccsMessage3}}</b>
            <br>
            800-292-3447 {{pageData?.notrefunded?.nccsMessage4}}
            <br>
            480-693-2759 {{pageData?.notrefunded?.nccsMessage5}}
            <br><br>
            <b>{{pageData?.notrefunded?.nccsMessage6}}</b>
            <br>
            American Airlines, Attention: Passenger Refunds
            <br>
            4000 East Sky Harbor Boulevard
            <br>
            Phoenix, Arizona, 85034
          </div>
          <div *ngSwitchCase="'USED'">
            {{pageData?.notrefunded?.usedMessage1}}
            <br><br>
            {{pageData?.notrefunded?.usedMessage2}}
            <br><br>
            {{pageData?.notrefunded?.usedMessage3}}
            <br><br>
            <a href="https://www.aa.com/contact/forms?topic=#/" target="_blank">{{pageData?.notrefunded?.usedMessage4}}
              <span aria-hidden="true" class="icon-newpage"></span></a>
            <br><br>
            {{pageData?.notrefunded?.usedMessage5}}
            <br><br>
            <a href="https://prefunds.aa.com/refunds/refundsContact"
              target="_blank">{{pageData?.notrefunded?.usedMessage6}} <span aria-hidden="true"
                class="icon-newpage"></span></a>
          </div>
          <div *ngSwitchCase="'PANA'">
            {{pageData?.notrefunded?.panaMessage1}} <span class="link-blue">{{'aawifihelp@panasonic.aero'}}</span>
            {{pageData?.notrefunded?.panaMessage2}}
          </div>
          <div *ngSwitchCase="'RADV'">
            {{pageData?.notrefunded?.radvMessage1}}
            <br><br>
            <a href="https://www.aa.com/contact/forms?topic=#/" target="_blank">{{pageData?.notrefunded?.radvMessage2}}
              <span aria-hidden="true" class="icon-newpage"></span></a>
          </div>
          <div *ngSwitchCase="'REAC'">
            {{pageData?.notrefunded?.reacMessage1}}
          </div>
          <div *ngSwitchCase="'EXPR'">
            {{pageData?.notrefunded?.exprMessage1}}
          </div>
          <div *ngSwitchCase="'DNLC'">
            <div *ngIf="refundStatusRs.refundStatus[0].statusDetails === 'BLANK'"></div>
            <div *ngIf="refundStatusRs.refundStatus[0].statusDetails === 'UNKNOWN'">
              <p *ngIf="isEmailPresent">{{pageData?.refunded?.emailMessage}} <span
                  class="link-blue">{{refundStatusRs.refundStatus[0].passengerContact.email | lowercase}}</span>.</p>
            </div>
          </div>
          <div *ngSwitchCase="'NRTC'">
            <p>{{pageData?.notrefunded?.nrtcMessage1}}</p>
            <p>
              <span>{{pageData?.notrefunded?.nrtcInsMessage1}}</span>
              <a href="https://www.aa.com" target="_blank">{{pageData?.general?.AALink}}
                <span aria-hidden="true" class="icon-newpage"></span></a>
              <span>{{pageData?.notrefunded?.nrtcInsMessage2}}</span>
            </p>
            <br />
            <div class="list-style standard-margin-bottom">
              <b id="NRTCHeading">{{pageData?.notrefunded?.nrtcLstHeader}}</b>
              <ul aria-labelledby="deniedNRTCHeading" class="list-header-padding">
                <li>{{pageData?.notrefunded?.nrtcLstMessage1}}</li>
                <li>{{pageData?.notrefunded?.nrtcLstMessage2}}</li>
                <li>{{pageData?.notrefunded?.nrtcLstMessage3}}</li>
              </ul>
            </div>
            <p>{{pageData?.general?.thanksByAmericanMessage1}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>